var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlaram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_31748)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_437_31748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9213 29.5898C33.1248 25.2033 32.9765 18.2399 28.5901 14.0364C24.2037 9.83288 17.2402 9.98118 13.0367 14.3676C8.95925 18.6225 8.95925 25.3348 13.0367 29.5898L10.1786 33.3999C9.84721 33.8418 9.93674 34.4686 10.3786 34.8C10.8204 35.1313 11.4472 35.0418 11.7786 34.6L14.5487 30.9058C18.3809 33.698 23.5771 33.698 27.4092 30.9058L30.1793 34.6C30.5106 35.0418 31.1375 35.1314 31.5793 34.8C32.0212 34.4686 32.1107 33.8417 31.7793 33.3999L28.9213 29.5898ZM21.9791 21.9995C21.9791 22.2159 21.9089 22.4264 21.7791 22.5995L18.779 26.5997C18.4476 27.0416 17.8208 27.1311 17.379 26.7997C16.9371 26.4683 16.8475 25.8415 17.179 25.3996L19.9791 21.6665V15.9993C19.9791 15.447 20.4268 14.9992 20.9791 14.9992C21.5315 14.9992 21.9792 15.447 21.9792 15.9993V21.9995H21.9791Z",
    fill: "#227C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5125 8.46396C13.5354 6.53604 10.3697 6.57594 8.44173 8.55308C6.54826 10.4949 6.54803 13.5922 8.44126 15.5343C8.83181 15.9247 9.46482 15.9247 9.8553 15.5343L15.5125 9.87806C15.9029 9.48751 15.9029 8.8545 15.5125 8.46396Z",
    fill: "#227C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5135 8.46396C31.5609 6.51195 28.3957 6.51195 26.4432 8.46396C26.0528 8.8545 26.0528 9.48751 26.4432 9.878L32.0994 15.5342C32.49 15.9246 33.123 15.9246 33.5135 15.5342C35.4655 13.5817 35.4655 10.4166 33.5135 8.46396Z",
    fill: "#227C42"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_31748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_437_31748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlaram);
export default __webpack_public_path__ + "static/media/alaram.aa188dd1478c805c2f91941834008291.svg";
export { ForwardRef as ReactComponent };